<template>
    <el-button @click="handleCreate">新建</el-button>
    <el-container style="width: 100%">
        <el-table :data="promptList">
            <el-table-column prop="id" label="ID" width="50" />
            <el-table-column prop="title" label="名称" width="150" />
            <el-table-column label="内容" width="400">
                <template #default="scope">
                    <pre style="max-height: 200px; overflow-y: scroll">{{ scope.row.content }}</pre>
                </template>
            </el-table-column>
            <el-table-column prop="temperature" label="温度" width="100" />
            <el-table-column prop="create_time" label="创建时间" width="150" :formatter="formatDate" />
            <el-table-column prop="update_time" label="更新时间" width="150" :formatter="formatDate" />
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-container>

    <el-dialog v-model="dialogFormVisible" title="问题" width="800">
        <el-form :model="form">
            <el-form-item label="名称">
                <el-input v-model="form.title" placeholder="" />
            </el-form-item>
            <el-form-item label="内容">
                <el-input v-model="form.content" type="textarea" placeholder="" :autosize="{ minRows: 3, maxRows: 15 }" />
            </el-form-item>
            <el-form-item label="温度">
                <el-input v-model="form.temperature" placeholder="" />
                0 - 1，值越大，回答越随机
            </el-form-item>
        </el-form>
        <template #footer>
            <div>
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSave">提交</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import * as api from '@/api';
import { ElNotification } from 'element-plus';

export default {
    data() {
        return {
            dialogFormVisible: false,
            form: {
                id: '',
                title: '',
                content: '',
                temperature: 0.9,
            },
            promptList: [],
        };
    },

    mounted() {
        this.getPromptList();
    },

    methods: {
        handleCreate() {
            this.form = {
                id: '',
                title: '',
                content: '',
                temperature: 0.9,
            };
            this.dialogFormVisible = true;
        },

        handleEdit(v) {
            this.form = {
                id: v.id,
                title: v.title,
                content: v.content,
                temperature: v.temperature,
            };
            this.dialogFormVisible = true;
        },

        handleSave() {
            if (this.form.id) {
                this.updatePrompt();
            } else {
                this.createPrompt();
            }
            this.dialogFormVisible = false;
        },

        getPromptList() {
            api.getPromptList().then(res => {
                this.promptList = res.data;
            });
        },

        updatePrompt() {
            const { id, title, content, temperature } = this.form;
            api.updatePrompt(id, title, content, temperature).then(res => {
                this.getPromptList();
                ElNotification({
                    title: 'Success',
                    type: 'success',
                });
            });
        },

        createPrompt() {
            const { title, content, temperature } = this.form;
            api.createPrompt(title, content, temperature).then(res => {
                this.getPromptList();
                ElNotification({
                    title: 'Success',
                    type: 'success',
                });
            });
        },

        formatDate(row, column, cellValue, index) {
            return this.$format.YmdHis(cellValue);
        },
    },
};
</script>
